// Global card-mode tables. Mount once (in App). On phones every <table> renders as a stack of
// labelled cards via CSS (index.css, ≤1023px); this component supplies the labels by copying each
// column header into the body cells' data-label, and keeps doing so as pages render, sort, filter
// and live-update — a MutationObserver means no page has to opt in or wire a hook.
// Opt OUT with class "table-grid" for tables that are true grids (e.g. the RBAC matrix).
import { useEffect } from 'react';

function label(table: HTMLTableElement): void {
  if (table.classList.contains('table-grid')) return;
  const headers = Array.from(table.querySelectorAll<HTMLTableCellElement>(':scope > thead th')).map(
    (th) => th.textContent?.trim() ?? '',
  );
  if (!headers.length) return;
  for (const row of Array.from(table.querySelectorAll<HTMLTableRowElement>(':scope > tbody > tr'))) {
    Array.from(row.cells).forEach((cell, i) => {
      const want = headers[i] ?? '';
      if (cell.getAttribute('data-label') !== want) cell.setAttribute('data-label', want);
    });
  }
}

function labelAll(root: ParentNode = document): void {
  root.querySelectorAll<HTMLTableElement>('table').forEach(label);
}

export function TableCards(): null {
  useEffect(() => {
    labelAll();
    let scheduled = false;
    const obs = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      // Batch bursts of DOM changes into one labelling pass per frame.
      requestAnimationFrame(() => {
        scheduled = false;
        labelAll();
      });
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => obs.disconnect();
  }, []);
  return null;
}
